/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
/**
 * 
 * @export
 * @interface TenantWithFeaturesDto
 */
export interface TenantWithFeaturesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TenantWithFeaturesDto
     */
    features?: Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof TenantWithFeaturesDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantWithFeaturesDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof TenantWithFeaturesDto
     */
    modifiedAt?: dayjs.Dayjs;
    /**
     * 
     * @type {Date}
     * @memberof TenantWithFeaturesDto
     */
    createdAt?: dayjs.Dayjs;
    /**
     * 
     * @type {string}
     * @memberof TenantWithFeaturesDto
     */
    createdByFullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantWithFeaturesDto
     */
    modifiedByFullName?: string | null;
}

/**
 * Check if a given object implements the TenantWithFeaturesDto interface.
 */
export function instanceOfTenantWithFeaturesDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantWithFeaturesDtoFromJSON(json: any): TenantWithFeaturesDto {
    return TenantWithFeaturesDtoFromJSONTyped(json, false);
}

export function TenantWithFeaturesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantWithFeaturesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'features': !exists(json, 'features') ? undefined : json['features'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'modifiedAt': !exists(json, 'modifiedAt') ? undefined : (dayjs(json['modifiedAt'])),

        'createdAt': !exists(json, 'createdAt') ? undefined : (dayjs(json['createdAt'])),

        'createdByFullName': !exists(json, 'createdByFullName') ? undefined : json['createdByFullName'],
        'modifiedByFullName': !exists(json, 'modifiedByFullName') ? undefined : json['modifiedByFullName'],
    };
}

export function TenantWithFeaturesDtoToJSON(value?: TenantWithFeaturesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'features': value.features,
        'id': value.id,
        'name': value.name,
        'modifiedAt': value.modifiedAt === undefined ? undefined : (value.modifiedAt.toISOString()),
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'createdByFullName': value.createdByFullName,
        'modifiedByFullName': value.modifiedByFullName,
    };
}

